// libraries
import clsx from 'clsx'

// components
import Video, { VideoProps } from '/react4xp/components/Video'

// types
interface MacroVideoProps {
    className?: string
    video?: VideoProps
    caption?: string
}

// css
import './index.scss'

export default function MacroVideo({
    className,
    video,
    caption
}: MacroVideoProps) {
    return (
        <div className={clsx(
            'video-macro-component',
            className
        )}>

            {video?.url && (
                <Video
                    url={video?.url || ''}
                    type={video?.type || 'default'}
                    aspectRatio='16:9'
                    image={video?.image} // 1320 x 750
                />
            )}

            {caption && (
                <p className='video-macro-component__caption body-small'>
                    {caption}
                </p>
            )}

        </div>
    )
}